<div
  [class.collapsed]='sidebarCollapsed()'
  class="layout-container"
>
    <header class="header">
        <lg-header
          (logout)='logOut()'
          (chantierSelected)="onChantierSelected($event)"
          [selectedChantier]="selectedChantier$ | async"
          [selectableUserChantiers]="selectableUserChantiers$ | async"
          [connectedUser]='connectedUser$ | async'
          [logoUrl]="logoUrl"
          >
        </lg-header>
    </header>
    <aside class="sidebar">
      <button class="toggle-btn" (click)="toggleSidebar()">
        @if (!sidebarCollapsed()){
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-left-fill" viewBox="0 0 16 16">
            <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"></path>
          </svg>
        } @else {
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
          </svg>
        }

        <i class="bi bi-caret-right-fill" [hidden]='!sidebarCollapsed()'></i>
      </button>
      <lg-menu class='sidebar-content'></lg-menu>
    </aside>
    <main class="main-content">
      <router-outlet ></router-outlet>
    </main>
    <footer class="footer">
        <lg-footer [backendVersion]="backendVersion$ | async"></lg-footer>
    </footer>
</div>
